import { AppState } from "../app.state";

export const getPasswordModalWindow = (state: AppState) => state.changePassword.isOpen;

export const getChangePasswordStatus = (state: AppState) => state.changePassword.loadStatus;
